(function () {
    function updateWishlistConsentVisibility() {
      var allowed = false;
  
      if (
        window.Shopify &&
        Shopify.customerPrivacy &&
        typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
      ) {
        allowed = Shopify.customerPrivacy.analyticsProcessingAllowed();
      }
  
      document.body.classList.toggle('wishlist-consent-allowed', !!allowed);
    }
  
    document.addEventListener('DOMContentLoaded', updateWishlistConsentVisibility);
    document.addEventListener('swym:initialized', updateWishlistConsentVisibility);
    document.addEventListener('visitorConsentCollected', updateWishlistConsentVisibility);
    document.addEventListener('trackingConsentAccepted', updateWishlistConsentVisibility);
  
    window.addEventListener('load', updateWishlistConsentVisibility);
  })();